// Play/Pause of video controls
class CustomSliderControls {
    constructor(element) {
      this.init(element);
    }
  
    init(element) {
        const container = element;
        const slider = Flickity.data(element.querySelector('.Slideshow__Carousel'));
        const slides = element.querySelectorAll('.Slideshow__Slide');
        const slidesCount = slides.length;
        const sliderPager = element.querySelector('.slider-pager');
        console.log('init', sliderPager,slidesCount);
        if (sliderPager && slidesCount > 1 ){
            this.initPager(slider,sliderPager);
        }


      const videoButtons = element.querySelector('.scrolling_video_btns');
      if (!videoButtons) return;
  
      this.initVideoControls(slider,videoButtons,container);


    }

    initVideoControls(slider, videoButtons, container){
        slider.on('select', (e) => {
            const selectedSlide = container.querySelector('.Slideshow__Slide.is-selected');
            console.log('selectedSlide',selectedSlide);
            if (selectedSlide) {
                if(selectedSlide.querySelector('video')){
                    videoButtons.classList.remove('hidden');
                }else{
                    videoButtons.classList.add('hidden');
                }
            }
        });
        videoButtons.addEventListener('click', (e) => this.handleClick(e, videoButtons, container));
    }

    initPager(slider,sliderPager){
        slider.on('select', (e) => {
            sliderPager.querySelector('.dot.is-selected').classList.remove('is-selected');
            sliderPager.querySelector('.dot[data-slide-index="' + slider.selectedIndex + '"]').classList.add('is-selected');

        });
        sliderPager.querySelectorAll('.dot').forEach(dot => {
            dot.addEventListener('click', (e) => {
                slider.select(dot.getAttribute('data-slide-index'));
            });
        });
    }
  
    handleClick(event, button, container) {
        console.log('handleClick',event,button);
      const playBtn = button.querySelector('.start_playing');
      const pauseBtn = button.querySelector('.pause_playing');
  

  
      // Handle slideshow videos
        const selectedSlide = container.querySelector('.Slideshow__Slide.is-selected');
        if (selectedSlide) {
          selectedSlide.querySelectorAll('video').forEach(video => {
            this.toggleVideo(video, event);
          });
        }
  
      // Toggle button visibility
      if (playBtn && pauseBtn) {
        playBtn.classList.toggle('hidden');
        pauseBtn.classList.toggle('hidden');
      }
    }
  
    toggleVideo(video, event) {
      if (!video) return;
  
      const isPause = event.target.closest('.pause_playing');
      const isPlay = event.target.closest('.start_playing');
  
      try {
        if (isPause) {
          video.pause();
        } else if (isPlay) {
          video.play().catch(err => console.error('Play failed:', err));
        }
      } catch (error) {
        console.error('Video control error:', error);
      }
    }
  }